import { defineRecipe } from '@plurall/elo-v3';

export const benchmarkingTabsRootRecipe = defineRecipe({
  className: 'benchmarking-tabs',
  base: {
    marginBlockEnd: 'padding.4xlarge',

    "& [data-scope='tabs'][data-part='list']": {
      width: 'auto !important',
      padding: 'padding.2xsmall 1px !important',
    },
    "& [data-scope='tabs'][data-part='list'] [role='none']": {
      backgroundColor: 'border.primary',
    },

    '& .elo-tabs-trigger': {
      color: 'text.primary',
      fontSize: 'font.size.small',
      fontWeight: 400,

      '&[aria-selected="true"]': {
        color: 'text.brand',
        fontWeight: 'font.weight.semi.bold',
      },
    },
  },
});
